// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".teal-lighten-4[data-v-673ec188]{background-color:#b2dfdb!important;color:#fff!important}.red-lighten-4[data-v-673ec188]{background-color:#ffcdd2!important;color:#fff!important}", ""]);
// Exports
module.exports = exports;
